// This import loads the firebase namespace along with all its type information.
import PlayerRole from './player-role-model'

export async function load_playerRoles(): Promise<PlayerRole[]> {
  throw 'Not implemented'
}

export async function delete_playerRole(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_playerRole(): Promise<PlayerRole> {
  throw 'Not implemented'
}
